import moment from 'moment';
import { observable, action, makeObservable, computed, toJS } from 'mobx';
import { meeting, user } from '.';
import { nowSpeakInOnePage } from '@/utils/common';
const statisDuration = 60 * 30; // 统计时长，单位s，对应weightArray数组的length
const speakDuration = 60 * 2; // 说话时长，单位s，对应SpeakWeightArray数组的length
const speakPercent = 10 * 0.8;
const minSpeakTimes = 2; // 2s内回调次数，至少2s
const InitWeightArray = new Array(statisDuration).fill(0);
const InitSpaeakWeightArray = new Array(speakDuration).fill(0);
// 计算时间差更新30分钟总说话权重的小标
function calcWeightIndex(updateTime: number, startTime: number) {
  const timeDiff = updateTime - startTime;

  const stepNumber = Math.round(timeDiff / 1000);
  if (stepNumber <= statisDuration - 1) {
    return stepNumber;
  }
  return stepNumber % statisDuration;
}

// 根据时间差计算更新2分钟说话权重的下标
function calcSpeakWeightIndex(updateTime: number, startTime: number) {
  const timeDiff = updateTime - startTime;

  const stepNumber = Math.round(timeDiff / 1000);
  if (stepNumber <= speakDuration - 1) {
    return stepNumber;
  }
  return stepNumber % speakDuration;
}
function updateWeightIndex(
  weightArray: Array<number>,
  weightIndex: number,
  weightValue: number,
  totalWeight: number
) {
  const sumWeight = totalWeight + weightValue - (weightArray[weightIndex] || 0);
  // const value = weightArray.length >= weightIndex - 1 ? 0 : weightArray[weightIndex];
  // const sumWeight = totalWeight + weightValue - value;
  // if (weightArray.length === weightIndex - 1) {
  //   weightArray.push(weightValue);
  // } else {
  weightArray[weightIndex] = weightValue;
  // }
  return sumWeight;
}

class speakWeightInstance {
  constructor() {
    makeObservable(this);
  }
  @observable userWeightMap: Map<
    string,
    {
      weightArray: Array<number>;
      totalWeight: number;
      voiceLevel: number;
      time: number; // 统计更新时间
      startTime?: number;
      speakWeightArray?: Array<number>; // 发言人2分钟权重统计
      speakTotalWeight?: number; // 发言人2分钟总权重统计
    } | null
  > = new Map();

  @observable speakDetectonSetting = {
    ignoreCallbackRateLessThan: 0.8,
    ignoreVolumeLessThan: 0,
  };

  @observable startRecordTime = 0;
  @observable previousSpeakYuxid = '';

  @observable nowBigSpeakYuxid = '';
  @action setPreviosusSpeakYuxid = (value: string) => {
    this.previousSpeakYuxid = value;
  };

  @action setNowBigSpeakYuxid = (value: string) => {
    this.nowBigSpeakYuxid = value;
  };

  @action setUserWeight(yxuid: string, voiceLevel: number) {
    const updateTime = Date.now();
    if (!this.startRecordTime) {
      this.startRecordTime = updateTime;
    }
    // 计算30分钟内的用户的权重
    let weightArray = this.userWeightMap.get(yxuid)?.weightArray || InitWeightArray;
    let totalWeight = this.userWeightMap.get(yxuid)?.totalWeight || 0;
    const isValidVoice = voiceLevel > this.speakDetectonSetting.ignoreVolumeLessThan ? 1 : 0;
    // 计算当前时间与会议开始时间的时间差，根据时间差计算出当前说话人的权重下标
    const weightIndex = calcWeightIndex(updateTime, this.startRecordTime);
    // console.log('---weightIndex', weightIndex);
    // console.log('---weightIndex-weightArray', weightArray);

    const sumWeight = updateWeightIndex(weightArray, weightIndex, isValidVoice, totalWeight);

    // 计算2分钟内的用户的权重
    let speakWeightArray = this.userWeightMap.get(yxuid)?.speakWeightArray || InitSpaeakWeightArray;
    let speakTotalWeight = this.userWeightMap.get(yxuid)?.speakTotalWeight || 0;
    const isSpeakValidVoice = voiceLevel > this.speakDetectonSetting.ignoreVolumeLessThan ? 1 : 0;
    // 计算当前时间与会议开始时间的时间差，根据时间差计算出当前说话人的权重下标
    const speakWeightIndex = calcSpeakWeightIndex(updateTime, this.startRecordTime);
    const speakSumWeight = updateWeightIndex(
      speakWeightArray,
      speakWeightIndex,
      isSpeakValidVoice,
      speakTotalWeight
    );

    // 发言人判定
    this.userWeightMap.set(yxuid, {
      voiceLevel,
      time: updateTime,
      weightArray,
      totalWeight: sumWeight,
      speakTotalWeight: speakSumWeight,
      speakWeightArray: speakWeightArray,
    });
    // console.log('本地说话人userWieght', {
    //   time: moment(this.userWeightMap.get(yxuid)?.time).format('HH:mm:ss'),
    //   voiceLevel: voiceLevel,
    //   index: calcWeightIndex(updateTime, this.startRecordTime),
    //   weightArray: toJS(this.userWeightMap.get(yxuid)?.weightArray),
    //   totalWeight: this.userWeightMap.get(yxuid)?.totalWeight,
    //   speakTotalWeight: this.userWeightMap.get(yxuid)?.speakTotalWeight,
    //   speakWeightArray: toJS(this.userWeightMap.get(yxuid)?.speakWeightArray),
    // });
  }

  @action setRemoteUserWeight(yxuid: string, voiceLevel: number) {
    const updateTime = Date.now();
    const time = this.userWeightMap.get(yxuid)?.time;
    let startTime = this.userWeightMap.get(yxuid)?.startTime;
    if (!startTime) {
      startTime = updateTime;
    }
    // 计算30分钟内的用户的权重
    let weightArray = this.userWeightMap.get(yxuid)?.weightArray || InitWeightArray;
    let totalWeight = this.userWeightMap.get(yxuid)?.totalWeight || 0;
    const isValidVoice = voiceLevel / 100 > this.speakDetectonSetting.ignoreVolumeLessThan ? 1 : 0;

    let sumWeight = totalWeight;
    // 如果time不存在或者updateTime与time相差1秒
    if (!time || Math.round((updateTime - time) / 1000) === 1) {
      const weightIndex = calcWeightIndex(updateTime, startTime);
      sumWeight = updateWeightIndex(weightArray, weightIndex, isValidVoice, totalWeight);
    } else {
      const stepTime = Math.round((updateTime - time) / 1000);
      // 补充index并计算sumWeight
      // 循环stepTime次
      for (let i = 0; i < stepTime; i++) {
        // 如果不是最后一次循环
        if (i !== stepTime - 1) {
          // 计算当前时间的权重下标
          const autoWeightIndex = calcWeightIndex((i + 1) * 1000 + time, startTime);
          // 更新权重数组并计算总权重
          sumWeight = updateWeightIndex(weightArray, autoWeightIndex, 0, sumWeight);
        } else {
          // 计算当前时间的权重下标
          const autoWeightIndex = calcWeightIndex((i + 1) * 1000 + time, startTime);
          // 更新权重数组并计算总权重
          sumWeight = updateWeightIndex(weightArray, autoWeightIndex, 1, sumWeight);
        }
      }
    }
    // console.log('远程说话人音量', voiceLevel);
    // console.log('远程说话人说话回调时间', moment(updateTime).format('HH:mm:ss'));

    // 记录2分钟用户的发言量
    let speakWeightArray = this.userWeightMap.get(yxuid)?.speakWeightArray || InitSpaeakWeightArray;
    let speakTotalWeight = this.userWeightMap.get(yxuid)?.speakTotalWeight || 0;
    const isSpeakValidVoice =
      voiceLevel / 100 > this.speakDetectonSetting.ignoreVolumeLessThan ? 1 : 0;

    let speakSumWeight = speakTotalWeight;
    // 如果time不存在或者updateTime与time相差1秒
    if (!time || Math.round((updateTime - time) / 1000) === 1) {
      const weightIndex = calcSpeakWeightIndex(updateTime, startTime);
      speakSumWeight = updateWeightIndex(
        speakWeightArray,
        weightIndex,
        isSpeakValidVoice,
        speakTotalWeight
      );
    } else {
      const stepTime = Math.round((updateTime - time) / 1000);
      // 补充index并计算speakSumWeight
      // 循环stepTime次
      for (let i = 0; i < stepTime; i++) {
        // 如果不是最后一次循环
        if (i !== stepTime - 1) {
          // 计算当前时间的权重下标
          const autoWeightIndex = calcSpeakWeightIndex((i + 1) * 1000 + time, startTime);
          // 更新权重数组并计算总权重
          speakSumWeight = updateWeightIndex(speakWeightArray, autoWeightIndex, 0, speakSumWeight);
        } else {
          // 计算当前时间的权重下标
          const autoWeightIndex = calcSpeakWeightIndex((i + 1) * 1000 + time, startTime);
          // 更新权重数组并计算总权重
          speakSumWeight = updateWeightIndex(speakWeightArray, autoWeightIndex, 1, speakSumWeight);
        }
      }
    }

    this.userWeightMap.set(yxuid, {
      voiceLevel,
      time: updateTime,
      weightArray,
      totalWeight: sumWeight,
      startTime: startTime,
      speakWeightArray,
      speakTotalWeight: speakSumWeight,
    });
    // console.log('远程说话人userWieght', {
    //   time: moment(this.userWeightMap.get(yxuid)?.time).format('HH:mm:ss'),
    //   startTime: moment(this.userWeightMap.get(yxuid)?.startTime).format('HH:mm:ss'),
    //   index: calcWeightIndex(
    //     this.userWeightMap.get(yxuid)?.time!,
    //     this.userWeightMap.get(yxuid)?.startTime!
    //   ),
    //   weightArray: toJS(this.userWeightMap.get(yxuid)?.weightArray),
    //   totalWeight: this.userWeightMap.get(yxuid)?.totalWeight,
    //   yxuid: yxuid,
    // });
  }

  @action setSpeakDetectonSetting(data: any) {
    this.speakDetectonSetting = data;
  }

  @action setSpeakUserMap(yxuid: string, data: any) {}

  @action setstartRecordTime(time: number) {
    this.startRecordTime = time;
  }

  @action clearRemoteUserWeight(yxUid: string) {
    this.userWeightMap.delete(yxUid);
  }

  @computed
  get userWeightArray() {
    const keys = [...this.userWeightMap.keys()];
    return keys.map((key: any) => {
      const value = this.userWeightMap.get(key);
      return {
        ...value,
        yxuid: key,
      };
    });
  }
  calcSpeakBigWeight() {
    // 计算当前2分钟内权重最大的话说者
    let now = Date.now(); // 计算的时间
    let nowBigWeightSpeak = 0; // 两分钟内最大权重记录，默认是0
    let nowBigSpeakYuxid; // 两分钟内最大权重的用户yuxid
    // 分别处理远程的用户音量和本地的用户音量
    this.userWeightArray.map((item: any) => {
      const yxuid = item?.yxuid;
      if (yxuid !== user.yxuid && item) {
        const startTime = item?.startTime;
        const lastUpdateTime = item?.time;

        const totalWeight = item.totalWeight;
        const weightArray = item.weightArray || [];
        let sumWeight = totalWeight || 0;

        if (totalWeight) {
          // 大于1s说明这个时间段内没有回调，需要自动把这段时间的权重更新，自动更新期间音量值全为0
          if (startTime && lastUpdateTime && Math.round((now - lastUpdateTime) / 1000) > 1) {
            const stepTime = Math.round((now - lastUpdateTime) / 1000);

            for (let i = 0; i < stepTime; i++) {
              const autoWeightIndex = calcWeightIndex((i + 1) * 1000 + lastUpdateTime, startTime);
              sumWeight = updateWeightIndex(weightArray, autoWeightIndex, 0, sumWeight);
            }
          }
        }

        const speakTotalWeight = item?.speakTotalWeight;
        const speakWeightArray = item?.speakWeightArray || [];
        let speakSumWeight = speakTotalWeight || 0;

        if (speakTotalWeight) {
          // 重新计算总权重和2分钟权重
          if (startTime && lastUpdateTime && Math.round((now - lastUpdateTime) / 1000) > 1) {
            //重新计算这个发言人的2分钟的发言量
            const stepTime = Math.round((now - lastUpdateTime) / 1000);
            for (let i = 0; i < stepTime; i++) {
              const autoWeightIndex = calcSpeakWeightIndex(
                (i + 1) * 1000 + lastUpdateTime,
                startTime
              );
              speakSumWeight = updateWeightIndex(
                speakWeightArray,
                autoWeightIndex,
                0,
                speakSumWeight
              );
            }
          }
        }
        // 不相等才说明当前发言人这段时间的发言量有变化，需要更新权重
        if (speakSumWeight !== speakTotalWeight || totalWeight !== sumWeight) {
          this.userWeightMap.set(yxuid, {
            ...item,
            weightArray,
            totalWeight: sumWeight,
            speakWeightArray,
            speakTotalWeight: speakSumWeight,
          });
        }

        if (nowBigWeightSpeak <= speakSumWeight && speakSumWeight > minSpeakTimes) {
          nowBigWeightSpeak = speakSumWeight;

          if (!nowSpeakInOnePage(meeting?.sortMembers, yxuid)) {
            nowBigSpeakYuxid = yxuid;
            nowBigWeightSpeak = speakSumWeight;
          }
        }
      } else {
        const speakTotalWeight = item?.speakTotalWeight || 0;
        if (speakTotalWeight > minSpeakTimes && nowBigWeightSpeak <= speakTotalWeight) {
          nowBigWeightSpeak = speakTotalWeight;
          if (!nowSpeakInOnePage(meeting?.sortMembers, yxuid)) {
            nowBigSpeakYuxid = yxuid;
            nowBigWeightSpeak = speakTotalWeight;
          }
        }
      }
    });
    // console.log(
    //   `函数调用----计算当前说话者nowBigSpeakYuxid ${moment(Date.now()).format('HH:mm:ss')}`,
    //   nowBigSpeakYuxid
    // );
    this.setNowBigSpeakYuxid(nowBigSpeakYuxid!);
    return nowBigSpeakYuxid;
  }
}

export default speakWeightInstance;
